import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const MkReducer = (state = '', { type, payload }) => {
    switch (type) {
        case MultichainActionType.SET_MK:
            return payload;
        default:
            return state;
    }
};
